import api from './api';

export interface HealthResponse {
  status: string;
  version: string;
  releaseName: string;
}

export async function fetchHealth(): Promise<HealthResponse> {
  return await api.get<HealthResponse>('/health', undefined, {
    showErrorToast: false,
  });
}
